import BatterTableDataView from "@/components/BatterTableDataView.vue";
import { ElMessage } from "element-plus";
import api from "@/api";
export default {
  name: "XhsAccountList",
  components: {
    BatterTableDataView
  },
  data() {
    return {};
  },
  methods: {
    freshData(data) {
      window.open(`https://www.xiaohongshu.com/user/profile/${data.userId}?ICECMD=READ_POSTS`, '_blank');
    },
    freshOfficeData() {
      window.open('https://creator.xiaohongshu.com/creator/notemanage?source=official', '_blank');
    },
    updateAuthorCare(id) {
      api.updateAuthorCare(id).then(() => {
        ElMessage.success('更新成功');
        this.$refs.accountList.fetchData();
      });
    },
    updateUs(id) {
      api.updateAuthorUs(id).then(() => {
        ElMessage.success('更新成功');
        this.$refs.accountList.fetchData();
      });
    },
    deleteAuthor(id) {
      api.deleteAuthor(id).then(() => {
        ElMessage.success('删除成功');
        this.$refs.accountList.fetchData();
      });
    },
    init() {}
  },
  mounted() {
    this.init();
  }
};